const PROFILE_CREATOR_PREFERENCE_MODEL_CLASS_NAME = 'ProfileCreatorPreference'

const PROFILE_CREATOR_PREFERENCE_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  PROFILE_ID: 'profileId',
  NOTIFICATION_DISABLED: 'notificationsDisabled',
  CREATOR_ID: 'creatorId'
}

export {
  PROFILE_CREATOR_PREFERENCE_MODEL_CLASS_NAME,
  PROFILE_CREATOR_PREFERENCE_MODEL_KEY
}
